import { createAction, props } from '@ngrx/store';
import { Participation } from 'src/app/models/participation.model';
export const loadParticipations = createAction(
    '[Participations] Load',
    props<{ userId: string }>()
  );
  
  export const loadParticipationsSuccess = createAction(
    '[Participations] Load Success',
    props<{ participations: Participation[] }>()
  );
  
  export const loadParticipationsFailure = createAction(
    '[Participations] Load Failure',
    props<{ error: string }>()
  );
  
  export const addParticipation = createAction(
    '[Participations] Add',
    props<{ participation: Participation }>()
  );
  export const resetParticipations = createAction('[Participations] Reset');